import React from 'react';
import PropTypes from 'prop-types';
import { Frame } from 'framer';
import { motion, AnimatePresence } from "framer-motion"

const Animation = (props) => {
    const {
        animation,
        boundingRect,
        onAnimationStart,
        onAnimationComplete,
        duration,
        delay,
    } = props;
    let updatedDuration = duration || 0.3
    // console.log(animation, boundingRect && boundingRect.height)
    // const popOutElement = React.cloneElement(element, {closeHandler: clickHandler})
    switch (animation) {
        case 'default':
            return (
                <motion.div key='content' size='100%' position="relative" background='transparent'
                    positionTransition
                    initial={{ opacity: 0}}
                    animate={{ opacity: 1}}
                    exit={{ opacity: 0}}
                    transition={{ duration: updatedDuration, delay: delay }}>
                        {props.children}
                </motion.div>
            )
        case 'appear':
            return (
                <motion.div key='content' size='100%' position="relative" background='transparent'
                    positionTransition
                    initial="collapsed"
                    animate="open"
                    exit="collapsed"
                    variants={{
                        open: { translateY: 0, opacity: 1},
                        collapsed: { translateY: 10,  opacity: 0}
                    }}
                    transition={{ duration: 0.2 }}>
                        {props.children}
                </motion.div>
            )
        case 'dropdown':
            return (
                <motion.div key='content' size='100%' position="relative" background='transparent'
                    initial="collapsed"
                    animate="open"
                    exit="collapsed"
                    variants={{
                        open: { scaleY: 1, originY: 0 },
                        collapsed: { scaleY: 0, originY: 0 }
                    }}
                    transition={{ duration: updatedDuration, ease: [0.04, 0.62, 0.23, 0.98] }}>
                    {props.children}
                </motion.div>
            )
        case 'swipe':
            return (
                <motion.div key='content' size='100%' position="relative" background='transparent'
                    initial="collapsed"
                    animate="open"
                    exit="collapsed"
                    variants={{
                        open: { width: 'auto', translateX: 0, originX: 0, opacity: 1},
                        collapsed: { width: 0, translateX: 500, originX: 0, opacity: 0}
                    }}
                    transition={{ duration: updatedDuration, ease: [0.04, 0.62, 0.23, 0.98] }}>
                    {props.children}
                </motion.div>
            )
        case 'swipeDown':
            return (
                <motion.div key='content' size='100%' position="relative" background='transparent'
                    initial="collapsed"
                    animate="open"
                    exit="collapsed"
                    variants={{
                        open: { height: 'auto', translateY: 0, originY: 0, opacity: 1},
                        collapsed: { height: 0, translateY: -100, originY: 0, opacity: 0}
                    }}
                    transition={{ duration: updatedDuration, ease: [0.04, 0.62, 0.23, 0.98] }}>
                    {props.children}
                </motion.div>
            )
        case 'expand':
            return (
                <motion.div key='content' size='100%' position="relative" background='transparent'
                    initial="collapsed"
                    animate="open"
                    exit="collapsed"
                    variants={{
                        open: { height: boundingRect && boundingRect.height || 'auto', opacity: 1 },
                        collapsed: { height: 0, opacity: 0 }
                    }}
                    transition={{ duration: updatedDuration, delay: delay }}
                    onAnimationStart={onAnimationStart} onAnimationComplete={onAnimationComplete}>
                    {props.children}
                </motion.div>
            )
        case 'collapse':
            return (
                <motion.div key='content' size='100%' position="relative" background='transparent'
                    initial="open"
                    animate="collapsed"
                    exit="open"
                    variants={{
                        open: {  height: "auto" },
                        collapsed: {  height: 0 }
                    }}
                    transition={{ duration: 0.5, ease: [0.04, 0.62, 0.23, 0.98] }}>
                    {props.children}
                </motion.div>
            )
        case 'slideRight':
            return (
                <motion.div key='content' size='100%' position="relative" background='transparent'
                    initial="collapsed"
                    animate="open"
                    exit="collapsed"
                    variants={{
                        open: { width: "auto" },
                        collapsed: { width: 0 }
                    }}
                    transition={{ duration: updatedDuration, ease: [0.04, 0.62, 0.23, 0.98] }}>
                    {props.children}
                </motion.div>
            )
        case 'openSide':
            return (
                <motion.div key='content' size='100%' position="relative" 
                    initial="collapsed"
                    animate="open"
                    exit="collapsed"
                    variants={{
                        open: {x: 0, width: 'auto'},
                        collapsed: {x: '-15rem', width: 0}
                    }}
                    transition={{ duration: updatedDuration, ease: [0.04, 0.62, 0.23, 0.98] }}>
                    {props.children}
                </motion.div>
            )
        case 'closeSide':
            return (
                <motion.div key='content' size='100%' position="relative" background='transparent'
                    initial="open"
                    animate="collapsed"
                    exit="open"
                    variants={{
                        open: { width: "auto", x: 0 },
                        collapsed: { width: '100vw', x:'-15rem' }
                    }}
                    transition={{ duration: 3, ease: [0.04, 0.62, 0.23, 0.98] }}>
                    {props.children}
                </motion.div>
            )
        case 'slideLeft':
            return (
                <motion.div key='content' size='100%' position="relative" background='transparent'
                    initial="collapsed"
                    animate="open"
                    exit="collapsed"
                    variants={{
                        open: { x: 0, height: 'auto' },
                        collapsed: { x: '50%', height: boundingRect ? boundingRect.height : 0}
                    }}
                    transition={{ duration: updatedDuration, ease: [0.04, 0.62, 0.23, 0.98] }}>
                    {props.children}
                </motion.div>
            )
        case 'exitRight':
            return (
                <motion.div key='content' size='100%' position="relative" background='transparent'
                    initial="collapsed"
                    animate="open"
                    exit="collapsed"
                    variants={{
                        open: { x: 0, height: 'auto' },
                        collapsed: { x: '-50%', height: boundingRect ? boundingRect.height : 0}
                    }}
                    transition={{ duration: updatedDuration, ease: [0.04, 0.62, 0.23, 0.98] }}>
                    {props.children}
                </motion.div>
            )
        case 'exitLeft':
            return (
                <motion.div key='content' size='100%' position="relative" background='transparent'
                    initial="open"
                    animate="collapsed"
                    exit="open"
                    variants={{
                        open: { width: 'auto'},
                        collapsed: { width: 0}
                    }}
                    transition={{ duration: updatedDuration, ease: [0.04, 0.62, 0.23, 0.98] }}>
                    {props.children}
                </motion.div>
            )
        case 'resize':
            return (
                <motion.div key='content' size='100%' position="relative" background='transparent'
                    initial="collapsed"
                    animate="open"
                    exit="collapsed"
                    variants={{
                        open: { height: 'auto' },
                        collapsed: { height: boundingRect ? boundingRect.height : 0 }
                    }}
                    transition={{ duration: updatedDuration }}>
                    {props.children}
                </motion.div>
            )
        case 'left':
            return (
                <motion.div key='content' size='100%' position="relative" background='transparent'
                    initial="collapsed"
                    animate="open"
                    exit="collapsed"
                    variants={{
                        open: { x: 0},
                        collapsed: { x: '100%'}
                    }}
                    transition={{ duration: updatedDuration, ease: [0.04, 0.62, 0.23, 0.98] }}>
                    {props.children}
                </motion.div>
            )
        case 'right':
            return (
                <motion.div key='content' size='100%' position="relative" background='transparent'
                    initial="collapsed"
                    animate="open"
                    exit="collapsed"
                    variants={{
                        open: { x: 0},
                        collapsed: { x: '-100%'}
                    }}
                    transition={{ duration: updatedDuration, ease: [0.04, 0.62, 0.23, 0.98] }}>
                    {props.children}
                </motion.div>
            )
        default:
            return (
                <div style={{width:'100%'}}>{props.children}</div>
            )
    }
}

export default Animation;

Animation.propTypes = {
    // animation: PropTypes.oneOf(['default', 'expand', 'collapse', 'slideRight', 'slideLeft', 'exitRight']),
    animation: PropTypes.string,
    boundingRect: PropTypes.object
}